import { combineReducers } from '@reduxjs/toolkit'
import subwebReducer from 'redux/subwebSlice'
import draftsSlice from 'redux/draftsSlice'
import sidenavSlice from 'redux/sidenavSlice'

const rootReducer = combineReducers({
  subweb: subwebReducer,
  drafts: draftsSlice,
  sidenav: sidenavSlice
})

export default rootReducer
